import React, { useState } from "react";
import { Checkbox, Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  // 이미 확인한 항목을 다시 열면 체크된 상태로 보여야 한다.
  isCompleted: boolean;
  onComplete: () => void;
}

/**
 * 상품 유형 안내 — 모달이 아니라 목록 안에서 펼쳐지는 유일한 태스크.
 *
 * 목록 행에 이미 `상품 유형 안내` 제목이 있으므로 펼친 본문에서 제목·요약을 다시 쓰지 않는다
 * (전달서 §8.1).
 */
function PathPickStartGuideProductTypeNotice({
  isCompleted,
  onComplete,
}: Props) {
  const { t } = useI18nHelper();
  const [isAgreed, setIsAgreed] = useState(isCompleted);

  return (
    <Flex flexDirection={"column"} gap={"12px"}>
      <Text textStyle={"body-sm-medium"} color={"#444440"}>
        {t("path_pick_guide:product_type.body_1")}
      </Text>
      <Text textStyle={"body-sm-medium"} color={"#444440"}>
        {t("path_pick_guide:product_type.body_2")}
      </Text>
      <Checkbox
        variant={"sj_design"}
        isChecked={isAgreed}
        onChange={(event) => setIsAgreed(event.target.checked)}
      >
        <Text textStyle={"body-sm-medium"} color={"#22221F"}>
          {t("path_pick_guide:product_type.agree")}
        </Text>
      </Checkbox>
      {/* 체크박스 아래 왼쪽에 둔다(전달서 §8.1). */}
      <Flex justifyContent={"flex-start"}>
        <AppButton
          variant={"primary"}
          isDisabled={!isAgreed}
          onClick={onComplete}
        >
          {t("path_pick_guide:product_type.next")}
        </AppButton>
      </Flex>
    </Flex>
  );
}

export default PathPickStartGuideProductTypeNotice;
